/**
 * Calculates the cumulative offset of an element relative to a parent element.
 */

const getCumulativeOffset = (
  element: HTMLElement,
  parent?: HTMLElement | null
): { left: number; top: number } => {
  let left = 0;
  let top = 0;
  let workingElement: HTMLElement | null = element;

  do {
    left += workingElement.offsetLeft || 0;
    top += workingElement.offsetTop || 0;
    workingElement = workingElement.offsetParent as HTMLElement | null;
  } while (workingElement && workingElement !== parent);

  if (workingElement === parent && workingElement) {
    left += workingElement.offsetLeft;
    top += workingElement.offsetTop;
  }

  return { left, top };
};

export { getCumulativeOffset };
